import React from "react";
import { Modal, Button } from "react-bootstrap";

export default function Payment(props) {

  const { onHide, show, onTicket, barcode, putTicketPaid } = props;

  const onPutPaid = (e) => {
    e.preventDefault();

    putTicketPaid(barcode)
    onTicket(barcode)
  };



  return (
    <Modal show={show} onHide={onHide} aria-labelledby="payment" centered>
      <form onSubmit={onPutPaid}>
        <Modal.Header closeButton>
          <Modal.Title id="payment">Ödəniş</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="col-12 pl-4 pr-4">
            <div className="row">Ödənişi təsdiqləməyə əminsiniz?</div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={() => onHide(false)}>
            Ləğv
          </Button>
          <Button type="submit">Ödənişi tamamla</Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
